export default __webpack_public_path__ + "static/media/frame-3.7ad545d5.png";